module.exports = __webpack_public_path__ + "img/sheet_many.6d53f3e9.svg";